import Bash from '../images/stack/Bash.svg'
import Bootstrap from '../images/stack/Bootstrap.svg'
import ChartJs from '../images/stack/ChartJs.svg'
import CSS from '../images/stack/CSS.png'
import Docker from '../images/stack/Docker.svg'
import Express from '../images/stack/Express.png'
import Git from '../images/stack/Git.svg'
import Github from '../images/stack/Github.svg'
import Graphql from '../images/stack/Graphql.svg'
import HTML from '../images/stack/HTML.png'
import Javascript from '../images/stack/Javascript.svg'
import K8s from '../images/stack/K8s.svg'
import MaterialUI from '../images/stack/MaterialUI.svg'
import MongoDB from '../images/stack/MongoDB.svg'
import Next from '../images/stack/Next.svg'
import NextJsCircle from '../images/stack/NextJsCircle.png'
import NodeJs from '../images/stack/NodeJs.svg'
import React from '../images/stack/React.png'
import Redux from '../images/stack/Redux.svg'
import Saas from '../images/stack/Saas.svg'
import Tailwind from '../images/stack/Tailwind.png'
import Typescript from '../images/stack/Typescript.svg'
import Vercel from '../images/stack/Vercel.svg'

const skillImage = {
    HTML,
    CSS,
    Javascript,
    React,
    NodeJs,
    Next,
    Redux,
    Tailwind,
    Bootstrap,
    MaterialUI,
    Express,
    Git,
    Github,
    Graphql,
    MongoDB,
    Vercel,
    ChartJs,
    Bash,
    Docker,
    K8s,
    NextJsCircle,
    Saas,
    Typescript,
}

export default skillImage;